export default __webpack_public_path__ + "static/media/green_cloud_formation.f44084ce.svg";